import { render, staticRenderFns } from "./EventTypesPage.vue?vue&type=template&id=e9238fd0"
import script from "./EventTypesPage.vue?vue&type=script&lang=js"
export * from "./EventTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports